<template>
  <div
    class="thumb"
    :class="{
      'thumb--active': active,
      'thumb--video': isVideoThumb,
    }"
    role="button"
    tabindex="0"
    @click.prevent="$emit('click')"
    @keydown.enter="$emit('click')"
    @keydown.space.prevent="$emit('click')"
  >
    <fn-picture
      :src="src"
      :alt="alt ? alt : ''"
      :width="width"
      :height="height"
    />
    <fn-icon
      v-if="isVideoThumb"
      icon="btn-play"
      color="grey-light"
      :size="videoThumbLarge ? 'm' : 's'"
    />
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
    },
    src: {
      type: String,
      required: true,
    },
    videoThumb: {
      type: Boolean,
    },
    videoThumbLarge: {
      type: Boolean,
    },
    alt: {
      type: String,
      default: '',
    },
    width: {
      type: [Number, String],
      default: '',
    },
    height: {
      type: [Number, String],
      default: '',
    },
  },
  emits: ['click'],
  computed: {
    isVideoThumb() {
      return this.videoThumb || this.videoThumbLarge;
    },
  },
};
</script>

<style lang="scss" scoped>
.thumb {
  display: block;
  border: 1px solid palette(grey, light);
  background-color: palette(sand, base);
  border-radius: 2px;
  overflow: hidden;
  transition: 0.1s ease-in all;
  cursor: pointer;
  height: 68px;
  width: 68px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  img {
    display: block;
    width: 100%;
  }

  &.thumb--active {
    border-color: palette(red);
    cursor: default;
  }

  &.thumb--video {
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  :deep(.icon) {
    position: absolute;
  }

  :deep(.picture) {
    &:focus-visible {
      @include focus-outline-layered;
    }
  }
}
</style>
